export default __webpack_public_path__ + "static/media/Wall_Conveyor_x3_Orange.256.246ad9ff.png";